/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Delete_ConfirmInputs */

const en_us2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand deletion is permanent`)
};

const pt_br2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entendo que a exclusão é permanente`)
};

const es_419_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiendo que la eliminación es permanente`)
};

const pt_pt2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compreendo que a eliminação é permanente`)
};

const fr_fr2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je comprends que la suppression est définitive`)
};

const de_de2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich verstehe, dass das Löschen endgültig ist`)
};

const it_it2_profile_editors_delete_confirm = /** @type {(inputs: Profile_Editors_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho capito che l'eliminazione è definitiva`)
};

/**
* | output |
* | --- |
* | "I understand deletion is permanent" |
*
* @param {Profile_Editors_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_delete_confirm = /** @type {((inputs?: Profile_Editors_Delete_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Delete_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_delete_confirm(inputs)
	if (locale === "es-419") return es_419_profile_editors_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_delete_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_delete_confirm(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_delete_confirm(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_delete_confirm(inputs)
	return en_us2_profile_editors_delete_confirm(inputs)
});
export { profile_editors_delete_confirm as "profile-editors.delete_confirm" }